import SiteInfoTypes from './SiteInfo.types';
export const setSiteInfo = info => ({
    type: SiteInfoTypes.SET_SITE_INFO,
    payload: info
});